"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeoRhythmDataClient = exports.NeoRhythmClient = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ble_utils_1 = require("../lib/ble-utils");
const c = __importStar(require("../lib/constants"));
const neorhythm_utils_1 = require("../lib/neorhythm-utils");
const socket_1 = require("../lib/socket");
// TODO: maybe use mixins for seprating SocketClass into separate class inherating from both MuseClient and SocketClient
// https://stackoverflow.com/questions/26948400/typescript-how-to-extend-two-classes
// TODO: Create a device class that neorhythm and other devices extend from
// TODO: maybe use mixins for seprating SocketClass into separate class inherating from both MuseClient and SocketClient
// https://stackoverflow.com/questions/26948400/typescript-how-to-extend-two-classes
class NeoRhythmClient extends socket_1.SocketClient {
    constructor(props) {
        super(props);
        //Device
        this.connectionStatus = new rxjs_1.BehaviorSubject(false);
        this.deviceName = null;
        this.gatt = null;
        this.service = null;
        //Control
        this.controlCharacteristic = null;
        this.controlResponse = null;
        //TODO: To be Removed, but is currently used in Muse and NeoRhythm
        this.eventMarkers = null;
        // NeoRhythm observables
        this.controlData = null;
        this.batteryLevel = null;
        this.stimulationCounter = null;
        this.predefinedProgram = null;
        this.stopStimulation = null;
        this.systemSetting = null;
        this.customProgram = null;
    }
    async initialize() {
        var _a;
        this.deviceName = this.gatt.device.name || null;
        this.service = await this.gatt.getPrimaryService(c.NEORHYTHM_SERVICE);
        // initialize data streams
        await this.handleControl();
        await this.handleBatteryLevel();
        await this.handleStimulationCounter();
        await this.handlePredefinedProgram();
        await this.handleStopStimulation();
        await this.handleSystemSetting();
        await this.handleCustomProgram();
        await ((_a = this.controlCharacteristic) === null || _a === void 0 ? void 0 : _a.startNotifications());
        // TODO: move init to constructor, so it can be used w/o connecting headband
        this.connectionStatus.next(true);
    }
    async start() { }
    async stop() { }
    async pause() { }
    async handleControl() {
        var _a;
        this.controlCharacteristic = await ((_a = this.service) === null || _a === void 0 ? void 0 : _a.getCharacteristic(c.NEORHYTHM_CHARACTERISTIC));
        this.controlData = (await ble_utils_1.observableCharacteristic(this.controlCharacteristic)).pipe(operators_1.map((d) => d), operators_1.share());
    }
    async handleBatteryLevel() {
        this.batteryLevel = this.controlData.pipe(operators_1.map(neorhythm_utils_1.decodeBatteryLevel), operators_1.filter((value) => value !== null), operators_1.share());
    }
    async handleStimulationCounter() {
        this.stimulationCounter = this.controlData.pipe(operators_1.map(neorhythm_utils_1.decodeStimulationCounter), operators_1.filter((value) => value !== null), operators_1.share());
    }
    async handlePredefinedProgram() {
        this.predefinedProgram = this.controlData.pipe(operators_1.map(neorhythm_utils_1.decodePredefinedProgram), operators_1.filter((value) => value !== null), operators_1.share());
    }
    async handleStopStimulation() {
        this.stopStimulation = this.controlData.pipe(operators_1.map(neorhythm_utils_1.decodeStopStimulation), operators_1.filter((value) => value !== null), operators_1.share());
    }
    async handleSystemSetting() {
        this.systemSetting = this.controlData.pipe(operators_1.map(neorhythm_utils_1.decodeSystemSetting), operators_1.filter((value) => value !== null), operators_1.share());
    }
    async handleCustomProgram() {
        this.customProgram = this.controlData.pipe(operators_1.map(neorhythm_utils_1.decodeCustomProgram), operators_1.filter((value) => value !== null), operators_1.share());
    }
    async getSystemSetting() {
        var _a;
        const dataView = neorhythm_utils_1.getSystemSetting();
        await ((_a = this.controlCharacteristic) === null || _a === void 0 ? void 0 : _a.writeValue(new Uint8Array(dataView.buffer)));
    }
    async getCurrentProgram() {
        var _a;
        const dataView = neorhythm_utils_1.getCurrentProgram();
        await ((_a = this.controlCharacteristic) === null || _a === void 0 ? void 0 : _a.writeValue(new Uint8Array(dataView.buffer)));
    }
    // TODO: It may be best to stick to the predefined duration associated with each program.
    async sendPredefinedProgram(program) {
        var _a, _b, _c;
        const programSelected = neorhythm_utils_1.setPredefinedProgram(program);
        if (!programSelected) {
            return null;
        }
        await ((_a = this.controlCharacteristic) === null || _a === void 0 ? void 0 : _a.writeValue(new Uint8Array(programSelected.programDataView.buffer)));
        await ((_b = this.controlCharacteristic) === null || _b === void 0 ? void 0 : _b.writeValue(new Uint8Array(programSelected.durationDataView.buffer)));
        await ((_c = this.controlCharacteristic) === null || _c === void 0 ? void 0 : _c.writeValue(new Uint8Array(programSelected.endDataView.buffer)));
    }
    async sendCustomProgram(program) {
        var _a, _b;
        const programSelected = neorhythm_utils_1.setCustomProgram(program);
        if (!programSelected) {
            return null;
        }
        await ((_a = this.controlCharacteristic) === null || _a === void 0 ? void 0 : _a.writeValue(new Uint8Array(programSelected.programDataView.buffer)));
        await ((_b = this.controlCharacteristic) === null || _b === void 0 ? void 0 : _b.writeValue(new Uint8Array(programSelected.endDataView.buffer)));
    }
    async injectMarker(value, timestamp = new Date().getTime()) {
        var _a;
        await ((_a = this.eventMarkers) === null || _a === void 0 ? void 0 : _a.next({ value, timestamp }));
    }
}
exports.NeoRhythmClient = NeoRhythmClient;
class NeoRhythmDataClient extends NeoRhythmClient {
    constructor(props) {
        super(props);
    }
    // TODO: Send neorhythm use back to database
    openStream(id) {
        this.id = id;
    }
    closeStream() { }
}
exports.NeoRhythmDataClient = NeoRhythmDataClient;
//# sourceMappingURL=neorhythm.js.map